// @flow
import { TimeUtil } from "../../../utils/datetime/DateTimeUtil";

import type { IConstraintModel } from "../../types";

/**
 */
class DateTimeTimeFormatConstraint implements IConstraintModel {
  _format: string;
  _formatLabel: string;

  /**
   */
  constructor(format: string, formatLabel: string) {
    this._format = format;
    this._formatLabel = formatLabel;
  }

  /**
   */
  get id(): string {
    return "Constraint.TimeFormat.InvalidFormat";
  }

  /**
   */
  get format(): string {
    return this._format;
  }

  /**
   */
  get formatLabel(): string {
    return this._formatLabel;
  }

  /**
   */
  hasValidation(): boolean {
    return true;
  }

  /**
   */
  get defaultMessage(): string {
    return "Time must be entered in the format ${format}"; // NOSONAR
  }

  /**
   */
  get parameters(): { format: string } {
    return { format: this.formatLabel };
  }

  /**
   */
  validate(value: string): boolean {
    if (!value) {
      return false;
    }

    return TimeUtil.hasFormat(value, this.format);
  }

  /**
   */
  get isMandatoryConstraint(): boolean {
    return false;
  }
}

export default DateTimeTimeFormatConstraint;
